export default __webpack_public_path__ + "static/media/logo.7f269b23.png";